module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-pt-PT.d3ab8274.jpg";